import mockData from './mockData'
const ua = navigator.userAgent
// 没有jsbridge对象且不是测试环境或线上环境的时候才启用mock
if (
  !window?.HCwebviewBridge?.postMessage &&
  !window?.webkit?.messageHandlers?.HCwebviewBridge?.postMessage &&
  !location.href.includes('hengchiauto.com')
) {
  console.info('---------- 非恒驰App环境，启用mock数据 ------------')
  if (ua.toLowerCase().indexOf('android') > -1) {
    window.HCwebviewBridge = {
      postMessage: postMessage,
    }
  } else {
    window.webkit = {
      messageHandlers: {
        HCwebviewBridge: {
          postMessage: postMessage,
        },
      },
    }
  }
}

function postMessage(params) {
  if (typeof params === 'string') {
    params = JSON.parse(params)
  }
  setTimeout(() => {
    const _mockData = mockData[params.methodName]
    typeof window[params.callback] === 'function' && window[params.callback](_mockData || {})
  }, 10)
}
